import {
  formatPercentageValue,
  formatNormalNumber,
  createKpiTileItem,
} from '../../../utils/helper';

export default {
  type: 'KpiTile',
  handler: (data) => {
    const { valuableActionsTaken, valuableActionsTakenDelta } =
      data?.getUserAdoptionScorecard?.data || {};

    return createKpiTileItem(
      'Valuable Actions Taken',
      formatNormalNumber(valuableActionsTaken),
      valuableActionsTakenDelta
        ? {
            isPositiveValue: valuableActionsTakenDelta >= 0,
            text: formatPercentageValue(valuableActionsTakenDelta),
            sideLabel: '',
            showArrow: Number(valuableActionsTakenDelta) !== 0,
          }
        : null
    );
  },
};
